import styled from 'styled-components';

export default {
  A: styled.a`
    text-decoration: none;
  `
};
